/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:36:25
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 17:01:31
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Cascader from './Cascader';
import DropDown from './DropDown';
import MultiSelections from './MultiSelections';
import Range from './Range';
import Single from './SingleSelection';

export enum EnumFilterType {
  SingleSelection = 'Single',
  MultipleSelection = 'Multiple',
  Range = 'Range',
  Cascader = 'Cascader',
  CustomWithDrop = 'CustomWithDrop',
  CustomWithoutDrop = 'CustomWithoutDrop',
}

const filtersMap = {
  [EnumFilterType.Range]: ({ props, keyWord }) => (
    <Range key={keyWord} {...props} />
  ),
  [EnumFilterType.Cascader]: ({ props, keyWord }) => (
    <Cascader key={keyWord} {...props} />
  ),
  [EnumFilterType.MultipleSelection]: ({ props, keyWord }) => (
    <MultiSelections key={keyWord} {...props} />
  ),
  [EnumFilterType.SingleSelection]: ({ props, keyWord }) => (
    <Single key={keyWord} {...props} />
  ),
  [EnumFilterType.CustomWithDrop]: ({ props, Component, keyWord }) => {
    const Comp = DropDown(Component, {});
    return <Comp key={keyWord} {...props} />;
  },
  [EnumFilterType.CustomWithoutDrop]: ({ props, Component, keyWord }) => {
    const Comp = Component;
    return <Comp key={keyWord} {...props} />;
  },
};

const getValues = (values = []) => {
  return values.map((i) => {
    return i.value;
  });
};

const FilterGroup = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //data=[{value,label}]
  const { filters = [], onChange, data = {} } = props;

  const _onConfirm = (e) => {
    if (onChange) onChange(e);
  };
  const generateFilters = (filters) => {
    return filters.map((i) => {
      const {
        type,
        keyWord,
        options,
        customConvertDataToFilter,
        dropdownProps,
        Component,
        onCustomConfirm,
        ...rest
      } = i;
      // console.log('i,', i);

      if (filtersMap[type]) {
        const originalSelectedValue = data[keyWord];
        let value = [];
        if (customConvertDataToFilter) {
          value = customConvertDataToFilter(originalSelectedValue);
        } else {
          value = getValues(originalSelectedValue || []);
        }
        const confirm = onCustomConfirm
          ? (e) => onCustomConfirm({ value: e, onChange })
          : _onConfirm;
        const _props = {
          onConfirm: confirm,
          value,
          options: options || [],
          keyWord,
          dropdownProps,
          ...rest,
        };
        return filtersMap[type]({ keyWord, props: _props, Component });
      } else {
        return <React.Fragment />;
      }
    });
  };

  //const [selected,setSelected]
  return (
    <div className={css.container}>
      <div className={css.filterText}>
        {getI18n('general.filterGroup.filter')}
      </div>
      {generateFilters(filters)}
    </div>
  );
};

export default FilterGroup;
